import MakeRequest from '../request';

export const initConformProcess = async ({ url, xApiKey, payload }) =>
  await MakeRequest({ endpoint: { url, xApiKey } }, { data: payload, method: 'post' });
